import { useCancelAppointmentMutation } from "../../../../../../../api/appointments/useCancelAppointmentMutation";
import { useAppointmentCancelNotificationQuery } from "../../../../../../../api/appointments/useAppointmentCancelNotificationQuery";
import { uiNotification } from "../../../../../../../services/UINotificationService";
import { NOTIFICATION_TYPE } from "../config";
import { useContext } from "../context";
import { extractApiError } from "../../../../../../../utilities/api";
import { useAppTranslation } from "../../../../../../../i18n/useAppTranslation";

export function useCancelAppointment({ isAdditionalProvider } = {}) {
  const { appointment, onClose, refetchAppointments } = useContext();
  const { tCommon: t } = useAppTranslation.Common();

  const { data: notification } = useAppointmentCancelNotificationQuery({
    appointmentId: appointment.id,
  });

  const { mutateAsync, isLoading } = useCancelAppointmentMutation({
    onError: (res) => {
      const message = extractApiError(res);
      if (message === "appointment_belongs_to_procedure") {
        uiNotification.error("Appointment belongs to a procedure");
      } else {
        uiNotification.error(
          t([
            `error.${message}`,
            "Failed to cancel appointment. Please try again later.",
          ]),
        );
      }
    },
    onSuccess: () => {
      uiNotification.success(
        isAdditionalProvider
          ? "Additional provider has been successfully removed from appointment"
          : "Appointment cancelled successfully.",
      );
      onClose();
      refetchAppointments();
    },
  });

  const initiate = ({
    charge,
    notificationType,
    notificationBody,
    isAdditionalProvider,
  } = {}) => {
    return mutateAsync({
      appointmentId: appointment.id,
      charge: charge || false,
      isAdditionalProvider,
      notification: isAdditionalProvider
        ? null
        : {
            type: notificationType || NOTIFICATION_TYPE.emailAndSms,
            body: notificationBody || notification?.bodyEmail,
            subject: notification?.subject,
            bodySms: notification?.bodySms,
            successMessage: notification?.successMessage,
          },
    });
  };

  return {
    initiate,
    isLoading,
  };
}
